import { Box, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import formatDateTime from '@product-framework/utils/formatDateTime';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import MultiValueDisplay from '@ui-framework/helpers/MultiValueDisplay';
import { DATE_FORMAT, FieldWrapperVerticalV2 } from '@ui-framework/index';
import dayjs from 'dayjs';

function SPPendingAcceptanceDispatch({ dispatch, serviceJob }) {
  const fields = [
    {
      name: 'dispatch_number',
      show: true,
      fontWeight: 'bold',
      label: {
        localeId: 'DISPATCH_NUMBER',
        defaultMessage: 'Dispatch Number',
      },
      control: 'text',
      value: dispatch?.dispatchNumber || '',
    },
    {
      name: 'response_date',
      show: true,
      label: {
        localeId: 'RESPONSE_DATE',
        defaultMessage: 'Response Date',
      },
      control: 'text',
      value: () => {
        let data = '';
        if (serviceJob?.dispatchEvent?.status === 'REJECTED') {
          data = serviceJob?.dispatchEvent?.rejectionDate
            ? dayjs(serviceJob?.dispatchEvent?.rejectionDate).format(
                DATE_FORMAT.LONG_DATE,
              )
            : '';
        }
        if (serviceJob?.dispatchEvent?.status === 'ACCEPTED_WITH_CONDITIONS') {
          data = serviceJob?.dispatchEvent?.acceptanceDate
            ? dayjs(serviceJob?.dispatchEvent?.acceptanceDate).format(
                DATE_FORMAT.LONG_DATE,
              )
            : '';
        }
        return data;
      },
    },
    {
      name: 'conditions_for_acceptacne',
      show: serviceJob?.dispatchEvent?.status === 'ACCEPTED_WITH_CONDITIONS',
      label: {
        localeId: 'CONDITIONS_FOR_ACCEPTANCE',
        defaultMessage: 'Conditions for Acceptance',
      },
      control: 'text',
      value: () => {
        const data = [];
        if (serviceJob?.dispatchEvent?.serviceDate) {
          data.push(
            <MultiValueDisplay title="Service Date:">
              {formatDateTime(
                serviceJob?.dispatchEvent?.serviceDate,
                serviceJob?.dispatchEvent?.serviceDateAfterHour,
                serviceJob?.dispatchEvent?.serviceDateBeforeHour,
              )}
            </MultiValueDisplay>,
          );
        }
        if (serviceJob?.dispatchEvent?.additionalMoney > 0) {
          data.push(
            <MultiValueDisplay
              type="currency"
              title="Additional Money:"
              sx={{ mb: 1 }}>
              {serviceJob?.dispatchEvent?.additionalMoney}
            </MultiValueDisplay>,
          );
        }
        if (serviceJob?.dispatchEvent?.reason) {
          data.push(
            <MultiValueDisplay title="Reason:" sx={{ mb: 1 }}>
              <ReadMoreText maxChars={250}>
                {serviceJob?.dispatchEvent?.reason}
              </ReadMoreText>
            </MultiValueDisplay>,
          );
        }
        if (serviceJob?.dispatchEvent?.acceptedLocation?.locationName) {
          data.push(
            <MultiValueDisplay title="Accepted Location:">
              {serviceJob?.dispatchEvent?.acceptedLocation?.locationName}
            </MultiValueDisplay>,
          );
        }
        return data?.map(d => <Box>{d}</Box>);
      },
      grid: 6,
    },
    {
      name: 'reject_reason',
      show: serviceJob?.dispatchEvent?.status === 'REJECTED',
      label: {
        localeId: 'REJECT_REASON',
        defaultMessage: 'Reject Reason',
      },
      control: 'text',
      value:
        (
          <ReadMoreText maxChars={360}>
            {serviceJob?.dispatchEvent?.reason}
          </ReadMoreText>
        ) || '',
      grid: 6,
    },
  ];

  return (
    <Grid2 container columnSpacing={10}>
      {fields
        .filter(f => f.show === true)
        .map(f => {
          const gridSize = f.grid || 3;
          return (
            <Grid2 key={f.name} xs={gridSize}>
              <FieldWrapperVerticalV2 key={f.name} field={f} errors={[]}>
                <Box>
                  <Typography
                    color="common.black"
                    fontWeight={f?.fontWeight}
                    variant="body2">
                    {typeof f.value === 'function' ? f.value() : f.value}
                  </Typography>
                </Box>
              </FieldWrapperVerticalV2>
            </Grid2>
          );
        })}
    </Grid2>
  );
}

export default SPPendingAcceptanceDispatch;
